import type { Faculty } from '@/lib/types';
import { coursePhotos } from './images';
import { FILES } from './files';

const rows: [keyof typeof coursePhotos, string, string][] = [
  ['electronics', 'Electronics', 'Circuits, components and electronic equipment.'],
  ['electrical', 'Electrical', 'Wiring, installations and electrical machines.'],
  ['mechanical', 'Mechanical', 'Machining, measurement and workshop practice.'],
  ['civil-interior', 'Civil & Interior Design', 'Drafting, building and interior design.'],
  ['computer', 'Computer (Software & Hardware)', 'Computer hardware, software and applications.'],
  ['professional', 'Professional', 'Office, commercial and professional skills.'],
  ['automobile', 'Automobile', 'Vehicle systems, servicing and repair.'],
  ['teacher-training', 'Teacher Training', 'Preparing teachers for the classroom.'],
  ['ac-refrigeration', 'Air Conditioning & Refrigeration', 'Installing and servicing cooling systems.'],
];

export const FACULTIES: Faculty[] = rows.map(([slug, name, desc], i) => ({
  slug,
  name,
  desc,
  n: String(i + 1).padStart(2, '0'),
  photo: coursePhotos[slug],
  syllabusUrl: FILES.syllabi[slug],
}));

export const findFaculty = (slug: string | undefined) => FACULTIES.find((f) => f.slug === slug);
